(ns basic-components.html-table.header-cell
  (:require [basic-components.inputs.footprint :refer [editor]]
            [frontend.utils :as fu]))

(defn cell [{:keys [column-meta set-sort! state]}]
  (let [col-key (:column/key column-meta)
        {:keys [sort-by-key sort-direction hover-col hover-row]} @state]
    [:span
     {:class "flex gap-2"
      :on-mouse-over (fn [_]
                       (swap! state assoc :hover-col col-key))
      :on-mouse-out  (fn [_]
                       (when (= col-key hover-col)
                         (swap! state dissoc :hover-col)))
      :on-click      (fn [e]
                       (when (:column/sortable? column-meta)
                         (.preventDefault e)
                         (.stopPropagation e)
                         (set-sort! [col-key (if (and (= col-key sort-by-key)
                                                      (= sort-direction :desc))
                                               :asc :desc)])))}
     (:column/label column-meta)
     [:span
      {:class-name (fu/cs "zap-table__headline-sort"
                          (when (and (not= col-key hover-col)
                                     (not= col-key sort-by-key))
                            "d-hidden"))}
      (when (:column/sortable? column-meta)
        (cond (not= col-key sort-by-key)
              [:i.fad.fa-sort]
              (= sort-direction :desc)
              [:i.fad.fa-sort-down]
              :else
              [:i.fad.fa-sort-up]))]]))

(defn group-heading [title class-name {:keys [column-meta cell-value row-data state]}]
  [:div
   [:span
    {:class-name class-name}
    title]
   [cell {:column-meta column-meta
          :set-sort!   (fn [[sort-key direction]]
                         (swap! state assoc
                                :sort-by-key sort-key
                                :sort-direction direction))
          :state       state}]])
